/** 단계(1단계/2단계)별 파일 최대 개수 */
export const MAX_STEP_FILES = 5;

export const LANGUAGE_OPTIONS = [
    { languageId: 1, languageName: 'Python' },
    { languageId: 2, languageName: 'Java' },
    { languageId: 3, languageName: 'C' },
    { languageId: 4, languageName: 'CPP' },
    { languageId: 5, languageName: 'CSharp' },
    { languageId: 6, languageName: 'NodeJS' },
    { languageId: 7, languageName: 'JavaScript' }
];

export const DIFFICULTY_OPTIONS = [
    { value: 'EASY', label: '쉬움' },
    { value: 'NORMAL', label: '보통' },
    { value: 'HARD', label: '어려움' },
];

/**
 * PromptCreateRequest 구조에 맞는 기본 프롬프트
 * - attemptOrder: 1 또는 2
 * - judgmentCriteria: 판단 기준 (필수)
 * - fewShotExamples: few-shot 예시 (필수)
 * - model, temperature, maxTokens
 */
export const DEFAULT_PROMPTS = [
    {
        attemptOrder: 1,
        model: 'gpt-4o-mini',
        judgmentCriteria: `1. 코드가 올바르게 작성되었는지 확인한다.
2. 코드가 올바르게 작성되었는지 확인한다.
3. 코드가 올바르게 작성되었는지 확인한다.
4. 코드가 올바르게 작성되었는지 확인한다.`,
        fewShotExamples: `(FAIL 예시)
User: 코드
AI: {
    "status": "FAIL", 
    "vulnerability": "보안 약점명", 
    "feedback": "권장 피드백 문구", 
    "improvement": "권장 개선 사항"
}

(PASS 예시)
User: 코드
AI: {
    "status": "PASS", 
    "vulnerability": "없음", 
    "feedback": "해설 또는 칭찬, 격려 문구", 
    "improvement": ""
}
`,
        temperature: 0.5,
        maxTokens: 2000,
    },
    {
        attemptOrder: 2,
        model: 'gpt-4o-mini',
        judgmentCriteria: `1. 코드가 올바르게 작성되었는지 확인한다.
2. 코드가 올바르게 작성되었는지 확인한다.
3. 코드가 올바르게 작성되었는지 확인한다.
4. 코드가 올바르게 작성되었는지 확인한다.`,
        fewShotExamples: `(FAIL 예시)
User: 코드
AI: {
    "status": "FAIL", 
    "vulnerability": "보안 약점명", 
    "feedback": "권장 피드백 문구", 
    "improvement": "권장 개선 사항"
}

(PASS 예시)
User: 코드
AI: {
    "status": "PASS", 
    "vulnerability": "없음", 
    "feedback": "해설 또는 칭찬, 격려 문구", 
    "improvement": ""
}
`,
        temperature: 0.5,
        maxTokens: 2000,
    },
];